export const handleReload = () => {
    window.location.reload();
};